import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types';
import { currentControlActive, setCurrentCurtain } from '../../action/roomControlAction'
//import ACControl from './ACControl'
import ACControlandSelect from './ACcontrolandSelect'
import LightControl from './lightControl'
import CurtainControl from './curtainControl'
import DoorControl from './doorControl'
import SpeakerControl from './speakerControl'
import { roomControl, buttonColor } from '../../JS/setColors'
import {
  controlElements, infoAction,
  speakerSetZoneAction, zoneName
} from '../../config/constant';
import {
  getSpeakerStatus, VDAStatusApi,
  TempChange, setCurrentLightScene,
  setPowerSwitch, speakerInfoAPI
} from '../../action/roomControlAction';
import { setLoadingMass, popupOpenClose, setDeviceLoginPage } from '../../action/action';

class RoomControl extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentActive: 0,
      loadingMass: false
    }
    this.props.currentControlActive(controlElements[0]);
  }

  componentDidMount() {
    let SessionToken = localStorage.getItem("GuestJourneySessionToken");
    let room = localStorage.getItem("room");
    roomControl(this.props.menuColor, 0);
    if (SessionToken && this.props.guestDetail.locationId && this.props.guestDetail.guestToken) {
      this.time = window.setTimeout(() => {
        if (this.state.loadingMass) {
          this.props.setLoadingMass(false);
          this.props.popupOpenClose(true, "Currently no connection to room control.");
          this.setState({ loadingMass: false });
        }
      }, 3000);
      this.props.setLoadingMass(true);
      this.setState({ loadingMass: true });
      this.props.VDAStatusApi(SessionToken, this.props.guestDetail, this.VDAStatusCallBack, zoneName);
      this.props.getSpeakerStatus("roomControl", this.props.guestDetail);
      speakerInfoAPI(this.props.guestDetail, infoAction);
    } else {
      console.log("we are not getting location ID to get connected speaker.");
      if (this.props.currentWidget.widgetType && !room || room === "null") {
        this.props.setDeviceLoginPage(true);
        console.log("room", room);
      } else {
        console.log("there is some bug in guest registration flow.")
      }
    }
  }
  onControlClick = (currentActiveControl, index) => {
    this.setState({ currentActive: index });
    this.props.currentControlActive(currentActiveControl);
    roomControl(this.props.menuColor, index);
  }

  VDAStatusCallBack = (status) => {
    let temp, lightScene = []
    if (this.state.loadingMass) {
      this.props.setLoadingMass(false);
      window.clearTimeout(this.time);
      this.setState({ loadingMass: false });
      if (!status) {
        this.props.popupOpenClose(true, "Network Error.");
      }
    }
    if (status) {
      buttonColor(this.props.menuColor);
      // this.props.lightScreens.map((iterator, index) => {
      //   if (index < 7) {
      //     if (iterator.value === "ON") {
      //       this.props.setCurrentLightScene(`light${iterator.id}`);
      //     }

      //     // for (let i = 0; i < this.props.lightScreens.length; i++) {
      //     //   if (this.props.lightScreens[i][`light${index + 1}`]) {
      //     //     if (this.props.lightScreens[i][`light${index + 1}`].value === "ON") {
      //     //       this.props.setCurrentLightScene(`light${index + 1}`);
      //     //     }
      //     //   }
      //     // }
      //   }
      // })
      // if (this.props.zone.hvac.powerSwitch === "ON") {
      //   if (this.props.powerSwitch === "ON") {
      //     document.getElementById("ac-power-switch").checked = true
      //   } else {
      //     document.getElementById("ac-power-switch").checked = false
      //   }
      // }
      // window.setTimeout(() => {
      //   if (this.props.zone.hvac && this.props.zone.hvac.temperatureValue) {
      //     temp = parseInt(this.props.zone.hvac.temperatureValue.slice(2, 4))
      //     this.props.TempChange(null, temp);
      //   }
      // }, 200);

      // if (this.props.curatinList.length > 0) {
      //   this.props.curatinList.map((iterator, index) => {
      //     if (iterator.label) {
      //       if (iterator.value === "ON") {
      //         this.props.setCurrentCurtain(`curtain${iterator.id}`);
      //       }

      //       // for (let i = 0; i < this.props.curatinList.length; i++) {
      //       //   if (this.props.curatinList[i][`curtain${index + 1}`]) {
      //       //     console.log("id", this.props.curatinList[i][`curtain${index + 1}`]);
      //       //     if (this.props.curatinList[i][`curtain${index + 1}`].value === "ON") {
      //       //       this.props.setCurrentCurtain(`${this.props.curatinList[i][`curtain${index + 1}`].name}ON`);
      //       //     }
      //       //   }
      //       // }
      //     }
      //   })
      // this.props.curatinList.map((iterator) => {
      //   if (iterator.value === "ON") {
      //     this.props.setCurrentCurtain(`${iterator.name}ON`);
      //   }
      // })
      // }
    }
  }

  onControlClickMobile = (event) => {
    let channelNumber = parseInt(event.target.value);
    console.log("channelNumber", channelNumber);
    if (Array.isArray(controlElements)) {
      controlElements.map((iterator, index) => {
        if (channelNumber === index) {
          this.setState({ currentActive: index });
          this.props.currentControlActive(controlElements[index]);
        }
        return 0;
      })
    }
  }
  currentSelected = (index) => {
    switch (index) {
      case 0:
        return <ACControlandSelect />
      case 1:
        return <LightControl />
      case 2:
        return <CurtainControl />
      case 3:
        return <DoorControl />
      case 4:
        return <SpeakerControl />
      default:
        return <div>nothing is selected.</div>
    }
  }
  render() {
    return (
      <div
        id="ico-room-ctl"
        className="contentSection columns h-100 center-v">
        <div
          id="activity-list"
          className="col col-2 h-100 m-r25"
          style={{
            background: 'rgba(255,255,255,0.95)',
            marginRight: 0
          }}>
          <div className="activity-heading all-caps"
            style={{ marginLeft: "5px" }}>
            {this.props.displayName}
          </div>
          <div className="activity-list-container">
            <div className="activity-list-dropdown">
              <select className="activity-list-controller"
                onChange={this.onControlClickMobile}>
                {
                  Array.isArray(controlElements) ?
                    controlElements.map((itertaor, index) => {
                      return (
                        <option value={index} >
                          {itertaor.controlName}
                        </option>
                      )
                    }) : ""
                }
              </select>
            </div>
            {
              Array.isArray(controlElements) ?
                controlElements.map((itertaor, index) => {
                  return (
                    <div id={`control${index}`}
                      className={this.state.currentActive === index ?
                        `activity-item current` :
                        "activity-item"}
                      onClick={() => { this.onControlClick(itertaor, index) }}>
                      <div style={{ color: "inherit" }} className="activity-item-name all-caps">
                        {itertaor.controlName}
                      </div>

                      <i style={{ color: "inherit" }} className="fa fa-chevron-right"></i>
                      <div className="activity-item-desc"></div>
                    </div>
                  )
                }) : ""
            }
          </div>
        </div>
        <div
          id="control-options"
          className="col col-2 h-100 results-col"
          style={{ background: 'rgba(204,204,204,0.8)' }}>
          {
            this.currentSelected(this.state.currentActive)
          }

        </div>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    currentControl: state.store.roomControl.currentControl,
    stringConst: state.store.home.stringConst,
    guestDetail: state.store.home.guestDetails,
    menuColor: state.store.home.MenuColor,
    zone: state.store.roomControl.RoomControlStatus.zone,
    lightScreens: state.store.roomControl.lightScreens,
    powerSwitch: state.store.roomControl.powerSwitch,
    curatinList: state.store.roomControl.curatinList,
    currentWidget: state.store.sideNavBar.currentWidget,
    displayName: state.store.sideNavBar.currentWidget.displayName
  }
}

RoomControl.propTypes = {
  currentControl: PropTypes.object,
  stringConst: PropTypes.object
}

RoomControl.defaultProps = {
  currentControl: {}
}
export default connect(
  mapStateToProps,
  {
    currentControlActive,
    getSpeakerStatus,
    VDAStatusApi,
    TempChange,
    setCurrentLightScene,
    setPowerSwitch,
    setCurrentCurtain,
    setLoadingMass,
    popupOpenClose,
    setDeviceLoginPage
  }
)(RoomControl);

/*

*/


